import { render, staticRenderFns } from "./StreamController.vue?vue&type=template&id=b5dc2ce0&scoped=true&"
import script from "./StreamController.vue?vue&type=script&lang=ts&"
export * from "./StreamController.vue?vue&type=script&lang=ts&"
import style0 from "./StreamController.vue?vue&type=style&index=0&id=b5dc2ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5dc2ce0",
  null
  
)

export default component.exports